import * as React from 'react';
import { debounce } from 'lodash';
import { Input } from './Form/Input';
import * as Icons from './Icons';
import { Button } from './Button';

interface ISearchState {
  value: string;
}
interface ISearchProps {
  withSubmitButton?: boolean;
  onChange: (searchTerm: string) => void;
}
class Search extends React.Component<ISearchProps, ISearchState> {
  state: ISearchState = {
    value: '',
  };

  onChange = (event: React.SyntheticEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    this.setState({ value });
    if (!this.props.withSubmitButton) {
      this.debouncedPropagateChange();
    }
  };

  propagateChange = (event?: React.SyntheticEvent<HTMLFormElement>) => {
    if (event) {
      event.preventDefault();
    }
    this.props.onChange(this.state.value.trim().toLowerCase());
  };
  debouncedPropagateChange = debounce(this.propagateChange, 200);

  render() {
    return (
      <form className="flex relative" onSubmit={this.propagateChange}>
        <span className="absolute pin-t pin-l leading-normal mt-2 ml-3 pointer-events-none">
          <Icons.Search size={16} />
        </span>
        <Input
          className="pl-10"
          name="search"
          small={true}
          autoComplete="off"
          value={this.state.value}
          onChange={this.onChange}
          placeholder="Search"
        />
        {this.props.withSubmitButton && (
          <Button className="ml-2" type="submit" primary={true} size="small">
            Search
          </Button>
        )}
      </form>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search.tsx